import { createRouter, createWebHashHistory } from 'vue-router'

const routes = [
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
